import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OrganizationResponse } from '@/services/organization/types';

interface OrganizationStore {
  currentOrganizationId: string | null;
  currentOrganization: OrganizationResponse | null;
  isLoading: boolean;

  // Actions
  setOrganizationId: (id: string | null) => void;
  setOrganization: (org: OrganizationResponse | null) => void;
  clearOrganization: () => void;
  setLoading: (loading: boolean) => void;
  updateOrganization: (updates: Partial<OrganizationResponse>) => void;
}

export const useOrganizationStore = create<OrganizationStore>()(
  persist(
    (set) => ({
      currentOrganizationId: null,
      currentOrganization: null,
      isLoading: false,

      setOrganizationId: (id) =>
        set({
          currentOrganizationId: id
        }),

      setOrganization: (org) =>
        set({
          currentOrganization: org,
          currentOrganizationId: org?.id || null,
          isLoading: false,
        }),

      clearOrganization: () =>
        set({
          currentOrganizationId: null,
          currentOrganization: null,
          isLoading: false,
        }),

      setLoading: (loading) =>
        set({ isLoading: loading }),

      updateOrganization: (updates) =>
        set((state) => ({
          currentOrganization: state.currentOrganization
            ? { ...state.currentOrganization, ...updates }
            : null,
        })),
    }),
    {
      name: 'organization-storage',
      partialize: (state) => ({
        currentOrganizationId: state.currentOrganizationId,
        currentOrganization: state.currentOrganization,
      }),
    }
  )
);
